import type { Identity } from '../types/auth';
import type { CalendarLinkSource } from '../services/calendarLinkSources';
import { CALENDAR_LINK_SOURCES } from '../services/calendarLinkSources';
import { getEventTeamPerms } from './eventTeamPermissions';
import { getLimitedTesseractTeamAccess, TESSERACT_TEAM_BUILD } from './tesseractTeamAccess';
import { canViewPartnerships } from './partnershipPermissions';

const BUILD_GROUPS = ['argus_build_panel', 'argus_build_lead', 'argus_build_admin', 'SPY_Super_admin'];

/**
 * The team modules whose calendar links this user may look up. Mirrors the
 * navigation gates for each module, so the calendar never asks a module the
 * user cannot open (the reverse-lookup endpoints answer 403 in that case).
 */
export function getCalendarLinkSources(identity: Identity | null, isDev: boolean): CalendarLinkSource[] {
  if (isDev) return [...CALENDAR_LINK_SOURCES];
  if (!identity) return [];

  const groups = Array.isArray(identity.raw?.custom?.groups) ? identity.raw.custom.groups : [];
  const hasAny = (wanted: readonly string[]) => wanted.some(group => groups.includes(group));
  const limited = getLimitedTesseractTeamAccess(identity, isDev);

  const sources: CalendarLinkSource[] = [];
  if (getEventTeamPerms(identity, isDev).canView) sources.push('events');
  if (hasAny(BUILD_GROUPS) || (limited != null && !limited.calendarViewOnly && limited.role === TESSERACT_TEAM_BUILD)) {
    sources.push('builds');
  }
  if (canViewPartnerships(identity)) sources.push('partnerships');
  return sources;
}
